import React from 'react'
import { componentKey, setRowsPerPage, setSkip, setSelectedPayer, setStatusFilter, setPayerFilterText } from './FilingHistorySlice'
import Heading from '../../../components/heading/Heading'
import { HEADING } from '../../../components/heading/constants/constants'
import Label from '../../../components/label/Label'
import Checkbox from '../../../components/checkbox/basecheckbox/Checkbox'
import { useDispatch, useSelector } from 'react-redux'
import SelectDropdown from '../../../components/dropdown/selectdropdown/SelectDropdown'
import { useEffect } from 'react'
import { getCategoryList, getFilingHistory, getFilingStatuses, getPayerList } from './FilingHistorySaga'
import styles from './FilingHistory.styles'
import { LABEL_WEIGHT } from '../../../components/label/constants'
import RichGrid from '../../../components/richgrid/RichGrid'
import { ROW_SELECTION_OPTIONS } from '../../../components/richgrid/constants'
import Loadable from '../../../components/loadable/Loadable'
import useGarbageCollector from '../../../../libs/garbagecollector/garbageCollectorHooks'
import { COMMON_LOADING_STATES, COMMON_LOADING_STATES_MESSAGE_MAP } from '../../constants/constants'
import useTxNavigate from '../../../../libs/txnavigate/TxNavigateHook'

export default function FilingHistory() {
	useGarbageCollector(componentKey)
	const { history, statusFilter, formCategory, payersList, selectedPayer, loadingState, rowsPerPage, skip, totalHistory, filingStatuses } = useSelector((state) => state[componentKey])
	const dispatch = useDispatch();
	const navigate = useTxNavigate();

	useEffect(() => {
		dispatch(getPayerList())
		dispatch(getFilingStatuses())
		dispatch(getCategoryList())
	}, []);

	useEffect(() => {
		var object = statusFilter.reduce(
			(obj, item) => Object.assign(obj, { [item.key]: item.value }), {});
		dispatch(getFilingHistory({ PageSize: rowsPerPage, PageNumber: (skip / rowsPerPage) + 1, payerId: selectedPayer.value, ...object }))
	}, [rowsPerPage, skip, selectedPayer, statusFilter]);

	const isChecked = (key) => {
		const filter = statusFilter.find(fil => fil.value !== "" && key === fil.key)
		if (filter) {
			return true
		}
		return false
	}

	const handleCheck = (key, checked) => {
		dispatch(setStatusFilter(statusFilter.map(filter => {
			if (filter.key === key) {
				if (checked) {
					return { ...filter, value: filter.key }
				}
				return { ...filter, value: '' }
			}
			return { ...filter }
		})))
	}
	const handlePayerChange = (name, selectedOption) => {
		dispatch(setSelectedPayer({ ...selectedOption }))
	}

	const getMessage = (row) => {
		switch(row.StatusType){
			case 2:
				return <span>A {row.FormName} has been {filingStatuses.find(status=> status.id === row.StatusType)?.value}. <span style={styles.refColor}>Ref# {row.RefNumber}.</span> <span style={{...styles.refColor, ...styles.linkHover}} onClick={() => navigateToForm(row) }>Click here</span> to View.</span>
			case 4:
				return <span><span style={styles.refColor}>Ref# {row.RefNumber}</span> has been {filingStatuses.find(status=> status.id === row.StatusType)?.value}. <span style={{...styles.refColor, ...styles.linkHover}} onClick={() => navigateToForm(row) }>Click here</span> to Download official {row.FormName}.</span>
			case 8:
			case 3:
				return <span><span style={styles.refColor}>Ref# {row.RefNumber}</span> has been {filingStatuses.find(status=> status.id === row.StatusType)?.value}. <span style={{...styles.refColor, ...styles.linkHover}} onClick={() => navigateToForm(row) }>Click here</span> to refile {row.FormName}.</span>
			case 7:
				return <span>A {row.FormName} has been {filingStatuses.find(status=> status.id === row.StatusType)?.value}. <span style={styles.refColor}>Ref# {row.RefNumber}</span> <span style={{...styles.refColor, ...styles.linkHover}} onClick={() => navigateToForm(row) }>Click here</span> to View.</span>
			case 5:
				return <span>State Filing has been Submitted for states. <span style={styles.refColor}>Ref# {row.RefNumber}</span> <span style={{...styles.refColor, ...styles.linkHover}} onClick={() => navigateToForm(row) }>Click here</span> to View.</span>
			case 6:
				return <span>State Reconciliation has been Submitted for states. <span style={styles.refColor}>Ref# {row.RefNumber}</span> <span style={{...styles.refColor, ...styles.linkHover}} onClick={() => navigateToForm(row) }>Click here</span> to View.</span>
			case 1:
				return <span>Payment for <span style={styles.refColor}>Ref# {row.RefNumber}</span> received. Amount : {row.Amount}</span>
			default:
				return <span style={styles.refColor}>Ref# {row.RefNumber}</span>
		}
	}

	const navigateToForm = (row) => {
		const category = formCategory.find( form => row.FormName.toLowerCase().includes(form.toLowerCase())) ? '944x' : '1099'
		navigate(`/forms/manage/federalforms?PayerId=${row.PayerId}&TaxYear=${row.TaxYear}&Category=${category}&FilterText=`)
	}

	const FILING_HISTORY_COLUMNS = [
		{
			field: "time",
			header: <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...styles.text }}>Time (PST)</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.Time}</span>
		},
		{
			field: "message",
			header: <Label weight={LABEL_WEIGHT[700]}>Message</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{getMessage(row)}</span>
		},
	]
	
	return (
		<>
			<Heading type={HEADING.H1}>Filing History</Heading>
			<Loadable currentState={loadingState.state} loadingStates={COMMON_LOADING_STATES.FILTER_LOADING} messageMap={COMMON_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true} >
				<div style={styles.actionsRow}>
					{statusFilter.map(filter =>
						<div style={styles.checkBox}>
							<Label>{filter.label}</Label>
							<Checkbox checked={isChecked(filter.key)} onChangeCb={(e) => handleCheck(filter.key, e.target.checked)} />
						</div>)}
					<div>
						<Label>Select Payer</Label>
						<SelectDropdown
							name="payer"
							value={{ label: selectedPayer.label, value: selectedPayer.value }}
							prefixProps={{ text: "" }}
							onSelectCb={(name, selectedOption) => handlePayerChange(name, selectedOption)}
							options={payersList}
						/>
					</div>
				</div>
			</Loadable>
			<Loadable currentState={loadingState.state} loadingStates={COMMON_LOADING_STATES.GRID_LOADING} messageMap={COMMON_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true} >
				<div style={styles.grid}>
					<RichGrid
						data={history}
						columns={FILING_HISTORY_COLUMNS}
						selectable={false}
						extractRowKey={(row) => row.RefNumber}
						paginationProps={{
							skip: skip,
							take: rowsPerPage,
							takeOptions: ROW_SELECTION_OPTIONS,
							onChangeTakeCb: (newTake) => {
								dispatch(setRowsPerPage(newTake));
								dispatch(setSkip(0))
							},
							total: totalHistory,
							onChange: (take, t) => {
								dispatch(setRowsPerPage(take));
								dispatch(setSkip(t))
							},
						}}
					/>
				</div>
			</Loadable>
		</>
	)
}